// import React, { useState, useEffect, useRef } from 'react';
// import { Phone, Mail, ArrowRight, Lightbulb, Play, Pause } from 'lucide-react';

// function Home() {
//   const [displayedText, setDisplayedText] = useState('');
//   const [currentImageIndex, setCurrentImageIndex] = useState(0);
//   const fullText = 'Discover the wild beauty of Tanzania in its natural habitat';

//   const video1Ref = useRef(null);
//   const video2Ref = useRef(null);
//   const [isPlaying1, setIsPlaying1] = useState(false);
//   const [isPlaying2, setIsPlaying2] = useState(false);

//   const images = [
//     'https://images.unsplash.com/photo-1678652778466-48398e0c9edb?q=80&w=1173&auto=format&fit=crop',
//     'https://images.unsplash.com/photo-1575550959106-5a7defe28b56?q=80&w=1170&auto=format&fit=crop',
//     'https://images.unsplash.com/photo-1489392191049-fc10c97e64b6?auto=format&fit=crop&q=60&w=600'
//   ];

//   const parks = [
//     {
//       name: 'Serengeti National Park',
//       parkImg: 'https://images.unsplash.com/photo-1704104381002-7c3598b22179?auto=format&fit=crop&q=60&w=600',
//       animalImg: 'https://images.unsplash.com/photo-1741850820274-5457a736b23a?auto=format&fit=crop&q=60&w=600',
//       highlight: 'The great migration – millions of wildebeest'
//     },
//     {
//       name: 'Ngorongoro Crater',
//       parkImg: '/21.jpg',
//       animalImg: '/64.jpg',
//       highlight: 'World’s largest intact volcanic caldera'
//     },
//     {
//       name: 'Tarangire National Park',
//       parkImg: '/15.jpg',
//       animalImg: '/9.jpg',
//       highlight: 'Ancient baobab trees'
//     },
//     {
//       name: 'Lake Manyara National Park',
//       parkImg: 'https://images.unsplash.com/photo-1623745493572-ef78d94249f3?auto=format&fit=crop&q=60&w=600',
//       animalImg: 'https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?q=80&w=500&auto=format&fit=crop',
//       highlight: 'Tree-climbing lions & flamingo lakes'
//     },
//     {
//       name: 'Kilimanjaro National Park',
//       parkImg: 'https://images.unsplash.com/photo-1489392191049-fc10c97e64b6?auto=format&fit=crop&q=60&w=600',
//       animalImg: 'https://images.unsplash.com/photo-1735637082404-9ac6bd1e56b0?auto=format&fit=crop&q=60&w=600',
//       highlight: 'Remote wilderness & African wild monkeys'
//     },
//     {
//       name: 'Arusha National Park',
//       parkImg: 'https://i.pinimg.com/1200x/ca/27/2e/ca272e254aa074047e171cf8e361a129.jpg',
//       animalImg: 'https://images.unsplash.com/photo-1551753730-efa985ec1511?auto=format&fit=crop&q=60&w=600',
//       highlight: 'Mount Meru & black-and-white colobus'
//     }
//   ];

//   useEffect(() => {
//     let index = 0;
//     const typingSpeed = 100;

//     const type = () => {
//       if (index < fullText.length) {
//         setDisplayedText(fullText.slice(0, index + 1));
//         index++;
//         setTimeout(type, typingSpeed);
//       }
//     };
//     type();

//     const carouselInterval = setInterval(() => {
//       setCurrentImageIndex((prev) => (prev + 1) % images.length);
//     }, 5000);

//     return () => clearInterval(carouselInterval);
//   }, [images.length]);

//   const toggleVideo1 = () => {
//     if (video1Ref.current) {
//       isPlaying1 ? video1Ref.current.pause() : video1Ref.current.play();
//       setIsPlaying1(!isPlaying1);
//     }
//   };

//   const toggleVideo2 = () => {
//     if (video2Ref.current) {
//       isPlaying2 ? video2Ref.current.pause() : video2Ref.current.play();
//       setIsPlaying2(!isPlaying2);
//     }
//   };

//   return (
//     <div className="overflow-x-hidden w-full">
//       {/* FONTS LOADED IN index.html */}

//       <style jsx>{`
//         @layer utilities {
//           .font-calligraphy { font-family: 'Great Vibes', cursive; }
//           .font-heading    { font-family: 'Cinzel', serif; }
//           .font-body       { font-family: 'Lora', serif; }
//           .font-button     { font-family: 'Montserrat', sans-serif; }
//         }
//       `}</style>

//       {/* ==== HERO ==== */}
//       <div className="relative w-full h-[110vh] overflow-hidden">
//         <div
//           className="absolute inset-0 w-full h-full"
//           style={{
//             backgroundImage: `url('${images[currentImageIndex]}')`,
//             backgroundSize: 'cover',
//             backgroundPosition: 'center top',
//             transition: 'background-image 1s ease-in-out'
//           }}
//         />
//         <div className="absolute inset-0 flex flex-col justify-center items-center px-4 z-10">
//           <div className="text-center text-white max-w-4xl mx-auto">
//             <h1 className="text-5xl sm:text-6xl lg:text-7xl font-calligraphy font-bold mb-6 leading-tight">
//               {displayedText}
//             </h1>
//             <p className="text-lg sm:text-xl mb-8 max-w-3xl mx-auto leading-relaxed font-body">
//               Experience unforgettable safari adventures, witness incredible wildlife, and explore stunning landscapes with our expert-guided tours.
//             </p>

//             <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
//               <button
//                 className="w-full sm:w-auto text-white font-button font-medium py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
//                 style={{ backgroundColor: '#2f4f2f' }}
//                 onMouseEnter={(e) => (e.target.style.backgroundColor = '#1a2f1a')}
//                 onMouseLeave={(e) => (e.target.style.backgroundColor = '#2f4f2f')}
//               >
//                 Explore Packages
//               </button>
//               <a
//                 href="https://vm.tiktok.com/ZMH7KNghm9fAN-Z5PTd/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="w-full sm:w-auto border-2 border-[#2f4f2f] text-white font-button font-medium py-3 px-8 rounded-lg hover:bg-[#2f4f2f]/30 transition-all duration-300"
//               >
//                 Watch Video
//               </a>
//             </div>
//           </div>
//         </div>

//         <div className="absolute bottom-0 left-0 right-0 bg-black/30 backdrop-blur-sm py-6 px-4 z-20">
//           <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl mx-auto">
//             {[
//               { num: '500+', label: 'Happy travelers' },
//               { num: '15+', label: 'National parks' },
//               { num: '10', label: 'Years experience' },
//               { num: '24/7', label: 'Support' }
//             ].map((s, i) => (
//               <div key={i} className="text-center text-white">
//                 <h2 className="text-3xl font-bold mb-1 font-heading text-[#2f4f2f]">{s.num}</h2>
//                 <span className="text-base font-body">{s.label}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* ==== CEO SECTION ==== */}
//       <section className="bg-white py-16 overflow-hidden">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="relative rounded-2xl overflow-hidden shadow-xl">
//             <img src="/8.jpg" alt="CEO Mugabe Robert on safari" className="w-full h-96 object-cover" />
//             <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
//             <div className="absolute inset-0 flex flex-col justify-center items-center text-center p-6 text-white">
//         <h2 className="text-lg max-w-3xl mx-auto font-bodyt">
//   Our CEO Travels With You
// </h2>
//               <p className="text-lg max-w-3xl mx-auto font-body">
//                 <strong>Mugabe Robert</strong>, our founder and CEO, personally joins select safari groups to ensure every detail is perfect.
//               </p>
//               <a
//                 href="/book-now"
//                 className="mt-6 inline-flex items-center font-button font-bold px-6 py-3 rounded-lg transition bg-[#1e3a1e] text-white hover:bg-[#0f1f0f]"
//               >
//                 Book Your Safari With the CEO
//                 <ArrowRight className="ml-2 w-5 h-5" />
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ==== 3-CARD ROW ==== */}
//       <section className="bg-gray-50 py-12 border-t border-gray-200 overflow-hidden">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {/* CARD 1 */}
//             <div className="bg-white rounded-2xl p-6 shadow-lg border border-[#9acd32]/10">
//               <Mail className="w-9 h-9 text-[#2f4f2f] mb-3 mx-auto" />
//               <h3 className="text-xl font-body font-bold text-[#2f4f2f] text-center mb-2">Get in touch</h3>
//               <p className="text-sm font-body text-gray-600 text-center mb-4">Ready for your Tanzanian adventure?</p>
//               <div className="space-y-3 text-sm">
//                 <a 
//                   href="mailto:safaris@tanzania-yetutravellers.com" 
//                   className="flex items-center justify-center text-[#2f4f2f] hover:text-[#9acd32] transition font-body"
//                 >
//                   <Mail className="w-4 h-4 mr-2" /> safaris@tanzania-yetutravellers.com
//                 </a>
//                 <a 
//                   href="tel:+255753182737" 
//                   className="flex items-center justify-center text-[#2f4f2f] hover:text-[#9acd32] transition font-body"
//                 >
//                   <Phone className="w-4 h-4 mr-2" /> +255 753 182 737
//                 </a>
//                 <a 
//                   href="/booking" 
//                   className="block mt-4 text-center px-5 py-2 bg-[#2f4f2f] text-white rounded-lg hover:bg-[#1a2f1a] transition font-button font-medium"
//                 >
//                   Book Now
//                 </a>
//               </div>
//             </div>

//             {/* CARD 2 - VIDEOS */}
//             <div className="bg-white rounded-2xl shadow-lg border border-[#9acd32]/10 overflow-hidden">
//               <div className="grid grid-cols-1 md:grid-cols-2 h-full">
//                 <div className="relative h-64 md:h-full cursor-pointer" onClick={toggleVideo1}>
//                   <video ref={video1Ref} src="/video.mp4" className="w-full h-full object-cover" muted playsInline />
//                   <div className="absolute inset-0 bg-black/30 flex items-center justify-center transition-all">
//                     {isPlaying1 ? <Pause className="w-12 h-12 text-white" /> : <Play className="w-12 h-12 text-white ml-1" />}
//                   </div>
//                 </div>
//                 <div className="relative h-64 md:h-full cursor-pointer" onClick={toggleVideo2}>
//                   <video ref={video2Ref} src="/airport.mp4" className="w-full h-full object-cover" muted playsInline />
//                   <div className="absolute inset-0 bg-black/30 flex items-center justify-center transition-all">
//                     {isPlaying2 ? <Pause className="w-12 h-12 text-white" /> : <Play className="w-12 h-12 text-white ml-1" />}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* CARD 3 */}
//             <div className="bg-white rounded-2xl p-6 shadow-lg border border-[#9acd32]/10">
//               <Lightbulb className="w-9 h-9 text-[#9acd32] mb-3 mx-auto" />
//               <h3 className="text-xl font-body font-bold text-[#2f4f2f] text-center mb-2">Did you know?</h3>
//               <p className="text-sm font-body text-gray-700 text-center">
//                 Olduvai Gorge — the <span className="font-bold text-[#9acd32]">"Cradle of Mankind"</span> — revealed the 1.8 million-year-old <span className="italic">"Nutcracker Man"</span> skull.
//               </p>
//               <p className="text-xs font-body text-gray-600 text-center mt-2">Walk where humanity began.</p>
//               <a 
//                 href="/destinations" 
//                 className="block mt-4 text-center px-5 py-2 bg-[#9acd32] text-[#2f4f2f] rounded-lg hover:bg-[#228b22] hover:text-white transition font-button font-medium"
//               >
//                 Explore Tours
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ==== NATIONAL PARKS ==== */}
//       <section className="py-20 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
//         <div className="max-w-7xl mx-auto px-6">
//           <div className="text-center mb-16">
//             <h2 className="text-5xl md:text-6xl font-calligraphy font-bold text-[#2f4f2f] mb-6">
//               Iconic National Parks of Tanzania
//             </h2>
//             <p className="text-xl font-body text-gray-700 max-w-3xl mx-auto">
//               From the endless plains of the Serengeti to the wildlife-packed Ngorongoro Crater – each park offers a unique safari experience.
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {parks.map((park, idx) => (
//               <div
//                 key={idx}
//                 className="group bg-white rounded-2xl overflow-hidden shadow-lg border border-[#9acd32]/20 transition-transform hover:-translate-y-2"
//               >
//                 <div
//                   className="h-64 bg-cover bg-center relative"
//                   style={{ backgroundImage: `url('${park.parkImg}')` }}
//                 >
//                   <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
//                   <div className="absolute top-4 right-4 w-20 h-20 opacity-0 group-hover:opacity-100 transition-all">
//                     <img src={park.animalImg} alt={park.name + ' animal'} className="w-full h-full object-cover rounded-full shadow-lg" />
//                   </div>
//                 </div>
//                 <div className="p-6">
//                   <h3 className="text-2xl font-body font-bold text-[#2f4f2f] mb-3 group-hover:text-[#228b22] transition">
//                     {park.name}
//                   </h3>
//                   <p className="text-[#9acd32] font-body font-semibold text-lg mb-4">{park.highlight}</p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <div className="text-center mt-20">
//             <a
//               href="/contact"
//               className="inline-flex items-center bg-[#2f4f2f] text-white font-button font-bold px-10 py-4 rounded-2xl text-lg shadow-xl hover:bg-[#1a2f1a] transform hover:scale-105 transition-all"
//             >
//               Plan Your Safari
//               <ArrowRight className="ml-3 w-6 h-6" />
//             </a>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Home;


import React, { useState, useEffect, useRef } from 'react';
import { Phone, Mail, ArrowRight, Lightbulb, Play, Pause } from 'lucide-react';

function Home() {
  const [displayedText, setDisplayedText] = useState('');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const fullText = 'Discover the wild beauty of Tanzania in its natural habitat';

  const video1Ref = useRef(null);
  const video2Ref = useRef(null);
  const [isPlaying1, setIsPlaying1] = useState(false);
  const [isPlaying2, setIsPlaying2] = useState(false);

  const images = [
    'https://images.unsplash.com/photo-1678652778466-48398e0c9edb?q=80&w=1173&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1575550959106-5a7defe28b56?q=80&w=1170&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1489392191049-fc10c97e64b6?auto=format&fit=crop&q=60&w=600'
  ];

  const parks = [
    {
      name: 'Serengeti National Park',
      parkImg: 'https://images.unsplash.com/photo-1704104381002-7c3598b22179?auto=format&fit=crop&q=60&w=600',
      animalImg: 'https://images.unsplash.com/photo-1741850820274-5457a736b23a?auto=format&fit=crop&q=60&w=600',
      highlight: 'The great migration – millions of wildebeest'
    },
    {
      name: 'Ngorongoro Crater',
      parkImg: '/21.jpg',
      animalImg: '/64.jpg',
      highlight: 'World’s largest intact volcanic caldera'
    },
    {
      name: 'Tarangire National Park',
      parkImg: '/15.jpg',
      animalImg: '/9.jpg',
      highlight: 'Ancient baobab trees'
    },
    {
      name: 'Lake Manyara National Park',
      parkImg: 'https://images.unsplash.com/photo-1623745493572-ef78d94249f3?auto=format&fit=crop&q=60&w=600',
      animalImg: 'https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?q=80&w=500&auto=format&fit=crop',
      highlight: 'Tree-climbing lions & flamingo lakes'
    },
    {
      name: 'Kilimanjaro National Park',
      parkImg: 'https://images.unsplash.com/photo-1489392191049-fc10c97e64b6?auto=format&fit=crop&q=60&w=600',
      animalImg: 'https://images.unsplash.com/photo-1735637082404-9ac6bd1e56b0?auto=format&fit=crop&q=60&w=600',
      highlight: 'Remote wilderness & African wild monkeys'
    },
    {
      name: 'Arusha National Park',
      parkImg: 'https://i.pinimg.com/1200x/ca/27/2e/ca272e254aa074047e171cf8e361a129.jpg',
      animalImg: 'https://images.unsplash.com/photo-1551753730-efa985ec1511?auto=format&fit=crop&q=60&w=600',
      highlight: 'Mount Meru & black-and-white colobus'
    }
  ];

  useEffect(() => {
    let index = 0;
    const typingSpeed = 100;

    const type = () => {
      if (index < fullText.length) {
        setDisplayedText(fullText.slice(0, index + 1));
        index++;
        setTimeout(type, typingSpeed);
      }
    };
    type();

    const carouselInterval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(carouselInterval);
  }, [images.length]);

  const toggleVideo1 = () => {
    if (video1Ref.current) {
      isPlaying1 ? video1Ref.current.pause() : video1Ref.current.play();
      setIsPlaying1(!isPlaying1);
    }
  };

  const toggleVideo2 = () => {
    if (video2Ref.current) {
      isPlaying2 ? video2Ref.current.pause() : video2Ref.current.play();
      setIsPlaying2(!isPlaying2);
    }
  };

  return (
    <div className="overflow-x-hidden w-full">

      {/* FONT UTILITIES */}
      <style jsx>{`
        @layer utilities {
          .font-calligraphy { font-family: 'Great Vibes', cursive; }
          .font-body       { font-family: 'Times New Roman', Times, serif; }
          .font-button     { font-family: 'Montserrat', sans-serif; }
        }
      `}</style>

      {/* ==== HERO ==== */}
      <div className="relative w-full h-[110vh] overflow-hidden">
        <div
          className="absolute inset-0 w-full h-full"
          style={{
            backgroundImage: `url('${images[currentImageIndex]}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center top',
            transition: 'background-image 1s ease-in-out'
          }}
        />
        <div className="absolute inset-0 flex flex-col justify-center items-center px-4 z-10">
          <div className="text-center text-white max-w-4xl mx-auto">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-calligraphy font-bold mb-6 leading-tight">
              {displayedText}
            </h1>
            <p className="text-lg sm:text-xl mb-8 max-w-3xl mx-auto leading-relaxed font-body" style={{ lineHeight: '1.7' }}>
              Experience unforgettable safari adventures, witness incredible wildlife, and explore stunning landscapes with our expert-guided tours.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
              <button
                className="w-full sm:w-auto text-white font-button font-medium py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
                style={{ backgroundColor: '#2f4f2f' }}
                onMouseEnter={(e) => (e.target.style.backgroundColor = '#1a2f1a')}
                onMouseLeave={(e) => (e.target.style.backgroundColor = '#2f4f2f')}
              >
                Explore Packages
              </button>
              <a
                href="https://vm.tiktok.com/ZMH7KNghm9fAN-Z5PTd/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto border-2 border-[#2f4f2f] text-white font-button font-medium py-3 px-8 rounded-lg hover:bg-[#2f4f2f]/30 transition-all duration-300"
              >
                Watch Video
              </a>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 bg-black/30 backdrop-blur-sm py-6 px-4 z-20">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl mx-auto">
            {[
              { num: '500+', label: 'Happy travelers' },
              { num: '15+', label: 'National parks' },
              { num: '10', label: 'Years experience' },
              { num: '24/7', label: 'Support' }
            ].map((s, i) => (
              <div key={i} className="text-center text-white">
                <h2 className="text-3xl font-body font-semibold mb-1" style={{ color: '#2f4f2f', lineHeight: '1.7' }}>{s.num}</h2>
                <p className="text-base font-body" style={{ lineHeight: '1.7' }}>{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ==== CEO SECTION ==== */}
      <section className="bg-white py-16 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6">
          <div className="relative rounded-2xl overflow-hidden shadow-xl">
            <img src="/8.jpg" alt="CEO Mugabe Robert on safari" className="w-full h-96 object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col justify-center items-center text-center p-6 text-white space-y-4">
              <h2 className="text-2xl font-body font-semibold" style={{ lineHeight: '1.7' }}>
                Our CEO Travels With You
              </h2>
              <p className="text-lg max-w-3xl mx-auto font-body" style={{ lineHeight: '1.7' }}>
                <strong>Mugabe Robert</strong>, our founder and CEO, personally joins select safari groups to ensure every detail is perfect.
              </p>
              <a
                href="/book-now"
                className="inline-flex items-center font-body font-medium px-6 py-3 rounded-lg transition bg-[#1e3a1e] text-white hover:bg-[#0f1f0f]"
                style={{ lineHeight: '1.7' }}
              >
                Book Your Safari With the CEO
                <ArrowRight className="ml-2 w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ==== 3-CARD ROW ==== */}
      <section className="bg-gray-50 py-12 border-t border-gray-200 overflow-hidden">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* CARD 1 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-[#9acd32]/10">
              <Mail className="w-9 h-9 text-[#2f4f2f] mb-3 mx-auto" />
              <h3 className="text-xl font-body font-semibold text-[#2f4f2f] text-center mb-2" style={{ lineHeight: '1.7' }}>Get in touch</h3>
              <p className="text-sm font-body text-gray-600 text-center mb-4" style={{ lineHeight: '1.7' }}>Ready for your Tanzanian adventure?</p>
              <div className="space-y-3 text-sm">
                <a 
                  href="mailto:safaris@tanzania-yetutravellers.com" 
                  className="flex items-center justify-center text-[#2f4f2f] hover:text-[#9acd32] transition font-body"
                  style={{ lineHeight: '1.7' }}
                >
                  <Mail className="w-4 h-4 mr-2" /> safaris@tanzania-yetutravellers.com
                </a>
                <a 
                  href="tel:+255753182737" 
                  className="flex items-center justify-center text-[#2f4f2f] hover:text-[#9acd32] transition font-body"
                  style={{ lineHeight: '1.7' }}
                >
                  <Phone className="w-4 h-4 mr-2" /> +255 753 182 737
                </a>
                <a 
                  href="/booking" 
                  className="block mt-4 text-center px-5 py-2 bg-[#2f4f2f] text-white rounded-lg hover:bg-[#1a2f1a] transition font-button font-medium"
                >
                  Book Now
                </a>
              </div>
            </div>

            {/* CARD 2 - VIDEOS */}
            <div className="bg-white rounded-2xl shadow-lg border border-[#9acd32]/10 overflow-hidden">
              <div className="grid grid-cols-1 md:grid-cols-2 h-full">
                <div className="relative h-64 md:h-full cursor-pointer" onClick={toggleVideo1}>
                  <video ref={video1Ref} src="/video.mp4" className="w-full h-full object-cover" muted playsInline />
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center transition-all">
                    {isPlaying1 ? <Pause className="w-12 h-12 text-white" /> : <Play className="w-12 h-12 text-white ml-1" />}
                  </div>
                </div>
                <div className="relative h-64 md:h-full cursor-pointer" onClick={toggleVideo2}>
                  <video ref={video2Ref} src="/airport.mp4" className="w-full h-full object-cover" muted playsInline />
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center transition-all">
                    {isPlaying2 ? <Pause className="w-12 h-12 text-white" /> : <Play className="w-12 h-12 text-white ml-1" />}
                  </div>
                </div>
              </div>
            </div>

            {/* CARD 3 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-[#9acd32]/10">
              <Lightbulb className="w-9 h-9 text-[#9acd32] mb-3 mx-auto" />
              <h3 className="text-xl font-body font-semibold text-[#2f4f2f] text-center mb-2" style={{ lineHeight: '1.7' }}>Did you know?</h3>
              <p className="text-sm font-body text-gray-700 text-center" style={{ lineHeight: '1.7' }}>
                Olduvai Gorge — the <span className="font-medium text-[#9acd32]">"Cradle of Mankind"</span> — revealed the 1.8 million-year-old <span className="italic">"Nutcracker Man"</span> skull.
              </p>
              <p className="text-xs font-body text-gray-600 text-center mt-2" style={{ lineHeight: '1.7' }}>Walk where humanity began.</p>
              <a 
                href="/destinations" 
                className="block mt-4 text-center px-5 py-2 bg-[#9acd32] text-[#2f4f2f] rounded-lg hover:bg-[#228b22] hover:text-white transition font-button font-medium"
              >
                Explore Tours
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ==== NATIONAL PARKS ==== */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-calligraphy font-bold text-[#2f4f2f] mb-6">
              Iconic National Parks of Tanzania
            </h2>
            <p className="text-xl font-body text-gray-700 max-w-3xl mx-auto" style={{ lineHeight: '1.7' }}>
              From the endless plains of the Serengeti to the wildlife-packed Ngorongoro Crater – each park offers a unique safari experience.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {parks.map((park, idx) => (
              <div
                key={idx}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg border border-[#9acd32]/20 transition-transform hover:-translate-y-2"
              >
                <div
                  className="h-64 bg-cover bg-center relative"
                  style={{ backgroundImage: `url('${park.parkImg}')` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute top-4 right-4 w-20 h-20 opacity-0 group-hover:opacity-100 transition-all">
                    <img src={park.animalImg} alt={park.name + ' animal'} className="w-full h-full object-cover rounded-full shadow-lg" />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-body font-semibold text-[#2f4f2f] mb-3 group-hover:text-[#228b22] transition" style={{ lineHeight: '1.7' }}>
                    {park.name}
                  </h3>
                  <p className="text-[#9acd32] font-body font-normal text-lg" style={{ lineHeight: '1.7' }}>
                    {park.highlight}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-20">
            <a
              href="/contact"
              className="inline-flex items-center bg-[#2f4f2f] text-white font-body font-medium px-10 py-4 rounded-2xl text-lg shadow-xl hover:bg-[#1a2f1a] transform hover:scale-105 transition-all"
              style={{ lineHeight: '1.7' }}
            >
              Plan Your Safari
              <ArrowRight className="ml-3 w-6 h-6" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;